import { useState } from "react";
import { useNavigate } from "react-router";
import { NavLink } from "react-router-dom"; // 1. Importa NavLink
import { useAuth } from "../views/AuthProvider";

export default function Header() {
    const { isAuthenticated, logout } = useAuth();
    const navigate = useNavigate();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const handleLogout = () => {
        logout();
        navigate('/iniciar');
    };

    // Función para definir las clases del NavLink
    const getNavLinkClass = ({ isActive }: { isActive: boolean }): string => {
        const baseClasses = "block md:inline-block hover:text-yellow-400 px-3 py-2 rounded-md text-sm font-medium";
        // Si el enlace está activo, añade la clase 'text-yellow-400', si no, 'text-white'
        return isActive ? `text-yellow-400 ${baseClasses}` : `text-white ${baseClasses}`;
    };

    const navLinks = (
        <>
            {!isAuthenticated ? (
                <>
                    {/* 2. Usa NavLink y aplica la función de clase */}
                    <NavLink to='/iniciar' className={getNavLinkClass}>Iniciar sesión</NavLink>
                </>
            ) : (
                <>
                    <NavLink to='/comprar' className={getNavLinkClass}>Comprar</NavLink>
                    <NavLink to='/mis-boletos' className={getNavLinkClass}>Mis boletos</NavLink>
                    <NavLink to='/ultimos-boletos' className={getNavLinkClass}>Últimos usados</NavLink>
                    <NavLink to='/mis-datos' className={getNavLinkClass}>Mis datos</NavLink>
                    <NavLink to='/nuevo-password' className={getNavLinkClass}>Cambiar contraseña</NavLink>
                    <button onClick={handleLogout} className="w-full md:w-auto text-left md:text-center bg-indigo-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-indigo-700 mt-2 md:mt-0">
                        Cerrar sesión
                    </button>
                </>
            )}
        </>
    );

    return (
        <header className="relative ml-4 w-[calc(100%-2rem)] mb-5">
            <nav className="flex pt-5 bg-[#1c325a] h-15 rounded-4xl p-4 items-center justify-between top-5">
                {/* Logo */}
                <div className="flex items-center justify-start gap-1">
                    <a href="../">
                        <div className="bg-white rounded-4xl h-[50px] w-[50px] flex overflow-hidden justify-center items-center">
                            <img className="h-[150%] w-[150%] block object-cover" src="/img/logo.webp" alt="Logo" />
                        </div>
                    </a>
                </div>

                {/* Menú para Escritorio */}
                <div className="hidden md:flex items-center space-x-4">
                    {navLinks}
                </div>

                {/* Botón de Hamburguesa */}
                <div className="md:hidden flex items-center">
                    <button
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                        className="text-white hover:text-yellow-400 focus:outline-none"
                    >
                        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            {isMenuOpen ? (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            ) : (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                            )}
                        </svg>
                    </button>
                </div>
            </nav>

            {/* Menú Desplegable para Móvil */}
            {isMenuOpen && (
                <div className="md:hidden absolute w-max right-0 mr-[10px] mt-2 bg-[#244583] rounded-xl shadow-lg/50 shadow-amber-50 z-10">
                {/* <div className="md:hidden absolute w-full mt-2 bg-[#244583] rounded-lg shadow-lg z-10"> */}
                    <div
                        className="flex flex-col p-4 space-y-2"
                        onClick={() => setIsMenuOpen(false)}
                    >
                        {navLinks}
                    </div>
                </div>
            )}
        </header>
    );
}